import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";

import { Observable } from "rxjs";
import { PagedData } from "../models/paging/paged-data";
import { Page } from "../models/paging/page";
import { Company } from "../models/company";
import { ServerData } from "../models/paging/server-data";

import { SnotifyService } from "ng-snotify";
import { environment } from "../../environments/environment";
import { AuthService } from "./auth.service";

@Injectable()
export class CompanyService {
  constructor(
    private http: HttpClient,
    private snotifyService: SnotifyService,
    private authService: AuthService
  ) {}
  //public user = JSON.parse(localStorage.getItem("currentUser"));

  public getAll(customer_Type_ID: number): Promise<Company[]> {
    const headers = {
      "Content-Type": "application/json",
    };

    return new Promise((resolve, reject) => {
      this.http
        .get<Company[]>(
          environment.apiUrl +
            "company/getall?customer_Type_ID=" +
            customer_Type_ID,
          { headers: headers }
        )
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {
            console.log(error);
            resolve(null);
          }
        );
    });
  }

  public get(id: number): Promise<Company> {
    return new Promise((resolve, reject) => {
      this.http
        .get<Company>(environment.apiUrl + "company/get?company_Id=" + id)
        .subscribe(
          (data) => {
            resolve(data);
          },
          (error) => {
            console.log(error);
            reject();
          }
        );
    });
  }

  public save(company: Company): Promise<any> {
    company.customer_Type_Id = Number(company.customer_Type_Id);

    if (company.customer_Type_Id == 0) {
      this.snotifyService.error("Please select a customer type");
      return;
    }

    console.log(company);
    console.log(environment.apiUrl + "company/Post");

    return new Promise((resolve, reject) => {
      if (company.is_edit) {
        this.http
          .put<any>(environment.apiUrl + "company/put", company)
          .subscribe(
            (data) => {
              if (data.success) {
                this.snotifyService.success("Successfully updated company");
                resolve(data);
              } else {
                this.snotifyService.error(
                  "Failed to update company: " + data.message
                );
                console.log(data.message);
                reject();
              }
            },
            (error) => {
              console.log(error);
              reject();
            }
          );
      } else {
        this.http
          .post<any>(environment.apiUrl + "company/Post", company)
          .subscribe(
            (data) => {
              console.log(data);

              if (data.success) {
                this.snotifyService.success("Successfully added company");
                resolve(data);
              } else {
                this.snotifyService.error(
                  "Failed to add company: " + data.message
                );
                console.log(data.message);
                reject();
              }
            },
            (error) => {
              this.snotifyService.success("Failed to add company: " + error);
              console.log(error);
              reject();
            }
          );
      }
    });
  }

  public getResults(
    page: Page,
    name: string,
    quick_Search: string
  ): Promise<PagedData<Company>> {
    const pagedData = new PagedData<Company>();

    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == "") {
        page.sortBy = "companyName";
      }
      if (page.sortOrder == undefined || page.sortOrder == "") {
        page.sortOrder = "asc";
      }

      let params = "&customer=" + name;
      params += "&quick_Search=" + quick_Search;

      this.http
        .get<ServerData>(
          environment.apiUrl +
            "company/GetTable?size=" +
            page.size +
            "&pageNumber=" +
            page.pageNumber +
            "&sortBy=" +
            page.sortBy +
            "&sortOrder=" +
            page.sortOrder +
            params
        )
        .subscribe(
          (data) => {
            page.totalElements = data.total;
            page.totalPages = page.totalElements / page.size;
            for (let i = 0; i < data.data.length; i++) {
              const jsonObj = data.data[i];
              pagedData.data.push(jsonObj);
            }

            pagedData.page = page;
            resolve(pagedData);
          },
          (error) => {
            reject();
          }
        );
    });
  }

  public getExcel(page: Page, name: string): Promise<any> {
    return new Promise((resolve, reject) => {
      let params = "?customer=" + name;

      this.http
        .get<any>(environment.apiUrl + "company/GetExcel" + params)
        .subscribe(
          (data) => {
            let blob = this.converBase64toBlob(
              data,
              "application/vnd.ms-excel"
            );
            resolve(blob);
          },
          (error) => {
            console.log(error);
            reject();
          }
        );
    });
  }

  converBase64toBlob(content, contentType) {
    contentType = contentType || "";
    let sliceSize = 512;
    let byteCharacters = window.atob(content); //method which converts base64 to binary
    let byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);
      let byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    let blob = new Blob(byteArrays, {
      type: contentType,
    }); //statement which creates the blob
    return blob;
  }
}
